import {Component} from '@angular/core';
import {ListViewItem} from "@domain/common/list-view/list-view-item";
import {ToastrService} from "ngx-toastr";
import {MatLegacyDialog as MatDialog} from "@angular/material/legacy-dialog";
import {filter,first} from "rxjs/operators";
import {Result,TypeCodeErreur} from "@domain/common/http/result";
import {TranslateService} from "@ngx-translate/core";
import {ConfirmService} from "@share/component/confirmation/confirm.service";
import {Bareme} from "@domain/prestation/bareme";
import {BaremeDetailPopinComponent} from "@components/admin/frais/prestations/prestation-detail/regles-gestion/bareme-detail-popin.component";
import {PrestationService} from "@services/admin/frais/prestation.service";
import {TypeBareme} from "@domain/prestation/TypeBareme";

/**
 * Item de liste d'un barème
 */
@Component({
	host: {'data-test-id': 'bareme-list-item'},
	templateUrl: './bareme-list-item.component.html'
})
export class BaremeListItemComponent extends ListViewItem<Bareme> {
	/** Types de barèmes possibles */
	protected readonly TypeBareme = TypeBareme;

	/**
	 * Constructeur
	 */
	constructor(
		private matDialog: MatDialog,
		private prestationService: PrestationService,
		private toastrService: ToastrService,
		private translateService: TranslateService,
		private confirmService: ConfirmService
	) {
		super();
	}

	/**
	 * Clic sur le barème
	 */
	onSelect(): void {
		//Ouverture de la popin de consultation/modification
		this.matDialog.open(BaremeDetailPopinComponent,{
			data: {
				bareme: this.data,
				typeBareme: this.liste.extraOptions.typeBareme,
				unite: this.liste.extraOptions.unite,
				mapLastBaremeByDate: this.prestationService.mapLastBaremeByDate(this.liste.data.listeResultats)
			},
			width: '65%'
		}).afterClosed().subscribe((refresh: boolean) => {
			if (refresh) {
				//Rafraîchissement de la liste
				this.liste.refresh();
			}
		})
	}

	/**
	 * Suppression de ce barème
	 */
	deleteBareme(): void {
		//Confirmation auprès de l'utilisateur sur la suppression d'un barème
		this.confirmService.showConfirm(this.translateService.instant('admin.frais.prestations.detail.reglesGestion.remboursement.bareme.popin.alerteSuppression'))
			.pipe(filter(isConfirmed => isConfirmed))
			.subscribe({
				next: () => {
					//Appel au service
					this.prestationService.deleteBareme(this.data.idBareme,this.liste.extraOptions.typeBareme)
						.pipe(first())
						.subscribe((result: Result) => {
							//Vérification du code d'erreur
							if (result.codeErreur === TypeCodeErreur.NO_ERROR) {
								//Toast succès
								this.toastrService.success(this.translateService.instant('global.success.suppression'));

								//Rafraîchissement de la liste
								this.liste.refresh();
							} else {
								//Gestion de l'erreur
								TypeCodeErreur.showError(result.codeErreur,this.translateService,this.toastrService);
							}
						});
				}
			});

	}
}
